export enum ChainId {
  MAINNET = 56,
  TESTNET = 97,
  LOCAL = 1337
}
